import { AnyAction, Middleware, Reducer, Store, combineReducers, configureStore } from '@reduxjs/toolkit'
import { CreditsState, creditsReducer as credits } from 'decentraland-dapps/dist/modules/credits/reducer'
import { FeaturesState, featuresReducer as features } from 'decentraland-dapps/dist/modules/features/reducer'
import { ProfileState, profileReducer as profile } from 'decentraland-dapps/dist/modules/profile/reducer'
import {
  StorageState,
  storageReducer as storage,
  storageReducerWrapper,
} from 'decentraland-dapps/dist/modules/storage/reducer'
import {
  TransactionState,
  transactionReducer as transaction,
} from 'decentraland-dapps/dist/modules/transaction/reducer'
import {
  TranslationState,
  translationReducer as translation,
} from 'decentraland-dapps/dist/modules/translation/reducer'
import { WalletState, walletReducer as wallet } from 'decentraland-dapps/dist/modules/wallet/reducer'

import { IdentityState, identityReducer as identity } from './identity/reducer'

export const createRootReducer = (middlewares: Middleware[], preloadedState = {}) =>
  configureStore({
    reducer: storageReducerWrapper(
      combineReducers<RootState>({
        wallet,
        storage,
        profile,
        features,
        translation: translation as Reducer<TranslationState, AnyAction>,
        identity,
        transaction,
        credits,
      })
    ),
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: {
          // Ignore these action types
          ignoredActions: [
            '[Request] Login',
            '[Success] Login',
            'Open modal',
            'REDUX_PERSISTENCE_SAVE',
            'REDUX_PERSISTENCE_LOAD',
          ],
          ignoredPaths: ['modal', 'identity'],
        },
      }).concat(middlewares),
  })

// We need to build the Store type manually due to the storageReducerWrapper function not propagating the type correctly
export type RootState = {
  identity: IdentityState
  storage: StorageState
  profile: ProfileState
  translation: TranslationState
  wallet: WalletState
  transaction: TransactionState
  features: FeaturesState
  credits: CreditsState
}

export type RootStore = Store<RootState>
export type RootReducer = Reducer<RootState>
